import React, { useEffect, useState } from 'react';
import { useWindowSize } from "@uidotdev/usehooks";
import { Container, Row, Col, Image, Card, Button, Form } from "react-bootstrap";

import Drawer from '@mui/material/Drawer';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import testData from '../logic/testData.json'
import { formatPhoneNumber, searchBarFilter } from '../logic/utils';
import DirectoryTable from './DirectoryTable';
import { fetchSafeAP } from '../logic/apiClass';
import SafeApMapPopup from '../safeApMap/ui/SafeApMapPopup';


const SafeAPDirectory = () => {
    const size = useWindowSize()
    // console.log(testData)

    const [drawerOpen, setDrawerOpen] = useState(false)
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(true)
    const [searchText, setSearchText] = useState("")
    const [filteredData, setFilteredData] = useState([])
    const [showPopup, setShowPopup] = useState(false)

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen)
    }

    useEffect(() => {
        if (loading) {
            fetchSafeAP(setTableData, setLoading)
        }
    }, [loading])

    useEffect(() => {
        searchBarFilter(tableData, searchText, setFilteredData)
    }, [tableData, searchText])

    const handleCloseModal=()=>{
        setShowPopup(false)
    }

    return (
        <div style={{ height: size.height, width: size.width, position: "relative" }}>
            <SafeApMapPopup handleCloseModal={handleCloseModal} showPopup={showPopup} tableData={tableData}/>
            <div style={{ backgroundColor: "#14417C", width: size.width, height: "22.5%", zIndex: "100", position: "absolute" }}>
                {/* Hello From SafeAP directory */}
            </div>

            <Container fluid
                style={{ position: "absolute", zIndex: "1000", left: "2.5%", paddingTop: "60px" }}
            >
                <h1 style={{ color: "white", fontWeight: "bolder" }}>SafeAP Directory</h1>
                <Card>

                    <Container fluid style={{ paddingTop: "20px", marginBottom: "20px" }}>
                        <Row>
                            <Col style={{ paddingTop: "9px" }}>
                                <h5>
                                    Directory
                                </h5>
                            </Col>
                            <Col>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search"
                                            value={searchText}
                                            onChange={(e) => {

                                                setSearchText(e.target.value)

                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Button style={{ backgroundColor: "#14417C" }} onClick={toggleDrawer}>Advanced Search</Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ backgroundColor: "#14417C" }} onClick={()=>{setShowPopup(true)}}>Map View</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                    <DirectoryTable data={filteredData} height={size.height} loading={loading} />
                </Card>
            </Container>
            <FilterDrawer drawerOpen={drawerOpen} toggleDrawer={toggleDrawer} />
        </div>

    );
};


function FilterDrawer({ drawerOpen, toggleDrawer }) {
    return (
        <Drawer anchor='right' open={drawerOpen} onClose={toggleDrawer}>
            <Box>
                Hello
            </Box>
        </Drawer>);
}

export default SafeAPDirectory;